import {ReactNode, useContext, createContext} from "react";
import {WalkMap} from "./types";

type EditContextType = {
  editNode: ReactNode;
  setEditNode: (node: ReactNode) => void;
  updatingCoordinate: number | null;
  setUpdatingCoordinate: (updating: number | null) => void;
  savedMaps: WalkMap[];
  savedMapsLoading: boolean;
  savedMapsError: boolean;
};

const EditContext = createContext<EditContextType | null>(null);

const useEditContext = () => {
  const currentContext = useContext(EditContext);

  if (!currentContext) {
    throw new Error(
      "useEditContext has to be used within <EditContext.Provider>",
    );
  }

  return currentContext;
};

export {EditContext, useEditContext};
